import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { FilePickerDirective } from './file-picker.directive';
export class AngularFilePickerModule { static decorators: DecoratorInvocation[] = [
{ type: NgModule, args: [{
  imports: [
    CommonModule
  ],
  declarations: [FilePickerDirective],
  exports: [FilePickerDirective]
}, ] },
];
/**
 * @nocollapse
 */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
];
}

function AngularFilePickerModule_tsickle_Closure_declarations() {
/** @type {?} */
AngularFilePickerModule.decorators;
/**
 * @nocollapse
 * @type {?}
 */
AngularFilePickerModule.ctorParameters;
}


interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
